document.addEventListener('DOMContentLoaded', () => {
  const menuDetails = document.querySelector('#Details-menu-drawer-container');
  const promoText = document.querySelector('#shopify-section-template--23836283928924__custom_liquid_FNpzdk .promo-text');

  // Promo section is currently disabled in the homepage template.
  // Exit silently if either element is absent (previously logged a
  // console error on every page load).
  if (!menuDetails || !promoText) return;

  // Function to manage promo text visibility
  const managePromoText = () => {
    if (window.innerWidth < 750) {
      // Mobile: toggle based on menu state
      if (menuDetails.hasAttribute('open')) {
        promoText.classList.add('hidden');
      } else {
        promoText.classList.remove('hidden');
      }
    } else {
      // Desktop: ensure mobile promo text is hidden
      promoText.classList.add('hidden');
    }
  };

  // Initial check
  managePromoText();

  // Listen for menu toggle (only affects mobile)
  menuDetails.addEventListener('toggle', managePromoText);

  // Recheck on window resize
  window.addEventListener('resize', managePromoText);
});
